import VideoPlayer from '@/components/VideoPlayer';
import { PreviewAnswerPopover } from './PreviewAnswerPopover';

interface VideoRecord {
  src?: string | null;
  width: number;
}

export default function VideoReplay({ src, width }: VideoRecord) {
  return (
    <VideoPlayer
      src={src ?? ''}
      width={width + 'px'}
      style={{
        position: 'relative',
        zIndex: 10,
        overflow: 'unset'
      }}
      type="video/mp4"
      autoPlay={false}
      PlayIcon={<PreviewAnswerPopover />}
      ReplayIcon={<PreviewAnswerPopover />}
    ></VideoPlayer>
  );
}
